<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col :span="10" class="logo" :class="collapsed ? 'logo-collapse-width' : 'logo-width'">{{ collapsed ? "" :
        sysName }}</el-col>
      <el-col :span="8" style=" text-align: left; font-size: 15px; margin-left: 20px;">
        <div v-if="userBillingDue <= 0"><el-button type="danger" effect="dark" @click="billingDueClick"
            style="color: white; background-color: red; font-size: 15px;">Cloud subscription payment due!</el-button>
        </div>
        <div v-else-if="userBillingDue <= 30"><el-button type="warning" effect="dark" @click="billingDueClick"
            style="color: white; background-color: orange; font-size: 15px;">Cloud subscription payment due
            soon!</el-button></div>
        <div v-else>{{ currentDateTime }}</div>
      </el-col>


      <el-col :span="6" class="userinfo">
        <el-dropdown trigger="hover">
          <span class="el-dropdown-link userinfo-inner" style="font-size: 18px">
            <img :src="this.sysUserAvatar" />
            {{ zone.name }}
          </span>
          <el-dropdown-menu slot="dropdown" style="width: 200px">
            <el-dropdown-item @click.native="$router.push('Zones')" v-if="user.role == 'admin'">Manage
              Zones</el-dropdown-item>
            <el-dropdown-item divided @click.native="profileClick">Profile</el-dropdown-item>
            <el-dropdown-item divided @click.native="$auth.logout()">Logout</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>
    <el-col :span="24" class="main">
      <aside :class="collapsed ? 'menu-collapsed' : 'menu-expanded'">
        <!--导航菜单-->
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose"
          @select="handleselect" unique-opened router v-show="!collapsed">
          <template v-for="(item, index) in $router.options.routes" v-if="!item.hidden">
            <el-submenu :index="index + ''" v-if="!item.leaf">
              <template slot="title">
                <i :class="item.iconCls"></i>
                {{ item.name }}
              </template>
              <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden">{{
                child.name }}</el-menu-item>
            </el-submenu>
            <el-menu-item v-if="item.leaf && item.children.length > 0" :index="item.children[0].path">
              <i :class="item.iconCls"></i>
              {{ item.children[0].name }}
            </el-menu-item>
          </template>
        </el-menu>
        <!--导航菜单-折叠后-->
        <ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
          <li v-for="(item, index) in $router.options.routes" v-if="!item.hidden" class="el-submenu item">
            <template v-if="!item.leaf">
              <div class="el-submenu__title" style="padding-left: 20px" @mouseover="showMenu(index, true)"
                @mouseout="showMenu(index, false)">
                <i :class="item.iconCls"></i>
              </div>
              <ul class="el-menu submenu" :class="'submenu-hook-' + index" @mouseover="showMenu(index, true)"
                @mouseout="showMenu(index, false)">
                <li v-for="child in item.children" v-if="!child.hidden" :key="child.path" class="el-menu-item"
                  style="padding-left: 40px" :class="$route.path == child.path ? 'is-active' : ''"
                  @click="$router.push(child.path)">
                  {{ child.name }}
                </li>
              </ul>
            </template>
            <template v-else>
          <li class="el-submenu">
            <div class="el-submenu__title el-menu-item"
              style="padding-left: 20px; height: 56px; line-height: 56px; padding: 0 20px"
              :class="$route.path == item.children[0].path ? 'is-active' : ''"
              @click="$router.push(item.children[0].path)">
              <i :class="item.iconCls"></i>
            </div>
          </li>
</template>
</li>
</ul>
</aside>
<section class="content-container">
  <div class="grid-content bg-purple-light">
    <el-col :span="24" class="breadcrumb-container">
      <!--<strong class="title">{{$route.name}}</strong>-->
      <el-breadcrumb separator="/" class="breadcrumb-inner">
        <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">{{ item.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col :span="24" class="content-wrapper">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </el-col>
  </div>
</section>
</el-col>
</el-row>
</template>

<script>
import Axios from "axios"
import SettingsService from "@/api/settings.service"
import UserService from "@/api/user.service"
import dateFormat from "dateformat"

export default {
  data() {
    return {
      zone: {
        name: ""
      },
      currentDateTime: "",
      dateUpdatePolling: null,
      componentKey: 0,
      lockDialog: {
        value: "",
        visible: false
      },
      sysName: "Vari-VAC Online",
      collapsed: false,
      sysUserName: "",
      sysUserAvatar: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      user: this.$session.get("User"),
      userBillingDue: 365
    }
  },
  methods: {
    profileClick() {
      this.$router.push("/Profile")
    },
    billingDueClick() {
      this.$router.push("/ZonesDashboard")
    },
    updateDateTime() {
      var now = new Date()
      this.currentDateTime = dateFormat(now, "dddd, mmmm dS, yyyy, h:MM:ss TT")
    },
    getZoneName(zoneid) {
      switch (zoneid) {
        case "00000000828a3f7d":
          return "920 Metcalf - Zone A"
        case "G6AY90300A7E":
          return "WestWinds - ZoneA"
      }
    },
    onSubmit() {
      console.log("submit!")
    },
    handleopen() {
      //console.log('handleopen');
    },
    handleclose() {
      //console.log('handleclose');
    },
    handleselect: function (a, b) { },
    //退出登录
    logout: function () {
      var _this = this
      this.$confirm("确认退出吗?", "提示", {
        //type: 'warning'
      })
        .then(() => {
          sessionStorage.removeItem("user")
          _this.$router.push("/login")
        })
        .catch(() => { })
    },
    //折叠导航栏
    collapse: function () {
      this.collapsed = !this.collapsed
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName("submenu-hook-" + i)[0].style.display = status ? "block" : "none"
    }
  },
  mounted() {
    this.dateUpdatePolling = setInterval(this.updateDateTime, 1000)
    this.updateDateTime()
    var user = localStorage.getItem("user")
    if (user) {
      user = JSON.parse(user)
      this.sysUserName = user.name || ""
      this.sysUserAvatar = user.picture || ""
      console.log(user.picture)
    }
    Axios.all([UserService.getZone(this.user.activeZone), UserService.getUserBillingDue(this.user)]).then(
      Axios.spread((zoneResponse, userBillingResponse) => {
        this.zone = zoneResponse.data
        if (userBillingResponse.data) {
          this.userBillingDue = userBillingResponse.data.billingDue
        }
      })
    )
    this.$root.$on("zoneChanged", () => {
      this.user = this.$session.get("User")
      console.log(this.user)
      Axios.all([UserService.getZone(this.user.activeZone), UserService.getUserBillingDue(this.user)]).then(
        Axios.spread((zoneResponse, userBillingResponse) => {
          this.zone = zoneResponse.data
          if (userBillingResponse.data) {
            this.userBillingDue = userBillingResponse.data.billingDue
          }
        })
      )
      console.log("changed")
    })
    if (this.user.role != "admin") {
      switch (this.user.role) {
        case "buildingAdminAdvanced":
          this.$router.options.routes.forEach(route => {
            switch (route.name) {
              case 'Zone Notes':
              case 'Zone Alarms':
              case 'Zone Logs':
              case 'Zone Notes':
              case 'ZoneInfo':
              case 'ZoneUsers':
              case 'UsersManager':
                route.hidden = true;
                break;
              default:
                break;
            }
          })
          break;
        case "buildingAdmin":
          this.$router.options.routes.forEach(route => {
            switch (route.name) {
              case 'Zone Notes':
              case 'Zone Alarms':
              case 'Zone Logs':
              case 'ZoneInfo':
              case 'ZoneUsers':
              case 'UsersManager':
              case 'Settings':
                route.hidden = true;
                break;
              default:
                break;
            }
          })
          break;
        default:
          this.$router.options.routes.forEach(route => {
            route.hidden = true;
          })
          break;
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.dateUpdatePolling)
  }
}
</script>

<style scoped lang="scss">
@import "~scss_vars";

.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;

  .header {
    height: 60px;
    line-height: 60px;
    background: $color-primary;
    color: #fff;

    .userinfo {
      text-align: right;
      margin-right: 35px;
      float: right;

      .userinfo-inner {
        cursor: pointer;
        color: #fff;

        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 0px 10px 10px;
          float: right;
        }
      }
    }

    .logo {
      //width:230px;
      height: 60px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;
      border-color: rgba(238, 241, 146, 0.3);
      border-right-width: 1px;
      border-right-style: solid;

      img {
        width: 40px;
        float: left;
        margin: 10px 10px 10px 18px;
      }

      .txt {
        color: #fff;
      }
    }

    .logo-width {
      width: 230px;
    }

    .logo-collapse-width {
      width: 60px;
    }

    .tools {
      padding: 0px 23px;
      width: 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
  }

  .main {
    display: flex;
    // background: #324057;
    position: absolute;
    top: 60px;
    bottom: 0px;
    overflow: hidden;

    aside {
      flex: 0 0 230px;
      width: 230px;

      // position: absolute;
      // top: 0px;
      // bottom: 0px;
      .el-menu {
        height: 100%;
      }

      .collapsed {
        width: 60px;

        .item {
          position: relative;
        }

        .submenu {
          position: absolute;
          top: 0px;
          left: 60px;
          z-index: 99999;
          height: auto;
          display: none;
        }
      }
    }

    .menu-collapsed {
      flex: 0 0 60px;
      width: 60px;
    }

    .menu-expanded {
      flex: 0 0 230px;
      width: 230px;
    }

    .content-container {
      // background: #f1f2f7;
      flex: 1;
      // position: absolute;
      // right: 0px;
      // top: 0px;
      // bottom: 0px;
      // left: 230px;
      overflow-y: scroll;
      padding: 20px;

      .breadcrumb-container {

        //margin-bottom: 15px;
        .title {
          width: 200px;
          float: left;
          color: #475669;
        }

        .breadcrumb-inner {
          float: right;
        }
      }

      .content-wrapper {
        background-color: #fff;
        box-sizing: border-box;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?7131aa82